import PropTypes from 'prop-types';
import H5 from '@base/H5/H5';
import Image from '@base/Image';
import P1 from '@base/P1/P1';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';

const transcriptConfig = {
  icon: '/doubts20/zap.svg',
  label: 'AUTO-GENERATED'
};

const TranscriptWrapper = styled.div`
  display: ${({ $isVisible }) => ($isVisible ? 'grid' : 'none')};
  grid-template-columns: 10px auto;
  gap: ${Spacings.SPACING_10} ${Spacings.SPACING_1B};
  margin-bottom: ${Spacings.SPACING_4B};
  margin-top: ${Spacings.SPACING_2};
`;

export const AutoGeneratedLabel = styled(H5)`
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.EXTRA_SMALL};
  display: flex;
  align-items: center;
  color: var(--color-text-secondary);
  line-height: ${Spacings.SPACING_10};
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.EXTRA_SMALL};
  }
`;
export const AutoGeneratedText = styled(P1)`
  font-weight: ${Fonts.LIGHT};
  color: var(--color-text-primary);
  grid-column: 1/3;
  font-size: ${Fonts.SMALL};
  line-height: ${Spacings.SPACING_5B};
`;

const AutoGeneratedIconWrapper = styled.div`
  position: relative;
  width: 10px;
  height: 10px;
`;

const Transcript = ({ config, ocrText, isVisible }) => {
  return (
    <TranscriptWrapper $isVisible={isVisible}>
      <AutoGeneratedIconWrapper>
        <Image src={config.icon} alt="zap-icon" layout="fill" />
      </AutoGeneratedIconWrapper>
      <AutoGeneratedLabel>{config.label}</AutoGeneratedLabel>
      <AutoGeneratedText>{ocrText}</AutoGeneratedText>
    </TranscriptWrapper>
  );
};

export default Transcript;

Transcript.propTypes = {
  config: PropTypes.objectOf(PropTypes.any)
};

Transcript.defaultProps = {
  config: transcriptConfig
};
